const getPermissionPath=(moduleName,permission)=>{
    return `${moduleName}.${permission}`;
}

export {getPermissionPath};